export const trackHeapEvent = (
  eventName: string,
  properties?: Record<string, string | number | boolean | null>
) => {
  if (typeof window.heap?.track === "function") {
    window.heap.track(eventName, properties || {});
  }
};
